import React from 'react';
import { Navigate } from 'react-router-dom';

const VendorRoute = ({ children }) => {
  const vendorToken = localStorage.getItem('vendorToken');
  const vendorData = localStorage.getItem('vendorData');
  
  if (!vendorToken || !vendorData) {
    return <Navigate to="/vendor/login" replace />;
  }

  try {
    // Validate that vendor data is parseable
    JSON.parse(vendorData);
    return children;
  } catch (error) {
    // Clear invalid data and redirect to login
    localStorage.removeItem('vendorToken');
    localStorage.removeItem('vendorData');
    return <Navigate to="/vendor/login" replace />;
  }
};

export default VendorRoute;
